import React from 'react';
import PropTypes from 'prop-types';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { Column } from 'web-ui-components/lib/global/layout';

import { CommonShell } from '../common/CommonShell/CommonShell';
import SweepCard from '../SweepCard';
import AccountTypeCard from '../AccountTypeCard';

const SweepsComponent = ({
  backClick,
  accountDetails,
  content,
  isEnabled,
  toggleOptionFactory,
  handleTargetAmountChange,
  targetAmount,
  savingAccountsAvailable,
  thresholdAmount,
  handleSweepCheck,
  handleThresholdAmountChange,
  isButtonDisabled,
  cancelSweepChange,
  confirmSweepChange,
  isLoading,
  showThresholdMsg,
  showTargetMsg,
  handleSweepAccountCardClick,
  showSweepAccountSelector,
  handleSelectSweepAccount,
  savingsAccountID,
  sweepError,
  errorModal,
  handleTargetOnBlur,
  handleThresholdOnBlur,
}) => (
  <CommonShell backClick={backClick}>
    <AccountTypeCard accountDetails={accountDetails} />
    <StandardBody>
      <p>{content.sweepText}</p>
    </StandardBody>
    <Column>
      <SweepCard
        toggleOptionFactory={toggleOptionFactory}
        isEnabled={isEnabled}
        handleSweepCheck={handleSweepCheck}
        content={content}
        targetAmount={targetAmount}
        handleTargetAmountChange={handleTargetAmountChange}
        savingAccountsAvailable={savingAccountsAvailable}
        thresholdAmount={thresholdAmount}
        handleThresholdAmountChange={handleThresholdAmountChange}
        isButtonDisabled={isButtonDisabled}
        cancelSweepChange={cancelSweepChange}
        isLoading={isLoading}
        confirmSweepChange={confirmSweepChange}
        showThresholdMsg={showThresholdMsg}
        showTargetMsg={showTargetMsg}
        handleSweepAccountCardClick={handleSweepAccountCardClick}
        showSweepAccountSelector={showSweepAccountSelector}
        handleSelectSweepAccount={handleSelectSweepAccount}
        savingsAccountID={savingsAccountID}
        handleTargetOnBlur={handleTargetOnBlur}
        handleThresholdOnBlur={handleThresholdOnBlur}
      />
    </Column>
    {sweepError && errorModal()}
  </CommonShell>
);

SweepsComponent.propTypes = {
  backClick: PropTypes.func,
  accountDetails: PropTypes.shape({}),
  content: PropTypes.shape({
    sweepText: PropTypes.string,
  }),
  isEnabled: PropTypes.bool,
  toggleOptionFactory: PropTypes.func,
  handleTargetAmountChange: PropTypes.func,
  targetAmount: PropTypes.string,
  savingAccountsAvailable: PropTypes.array,
  thresholdAmount: PropTypes.string,
  handleSweepCheck: PropTypes.func,
  handleThresholdAmountChange: PropTypes.func,
  isButtonDisabled: PropTypes.bool,
  cancelSweepChange: PropTypes.func,
  confirmSweepChange: PropTypes.func,
  isLoading: PropTypes.bool,
  showThresholdMsg: PropTypes.bool,
  showTargetMsg: PropTypes.bool,
  handleSweepAccountCardClick: PropTypes.func,
  showSweepAccountSelector: PropTypes.bool,
  handleSelectSweepAccount: PropTypes.func,
  savingsAccountID: PropTypes.string,
  sweepError: PropTypes.bool,
  errorModal: PropTypes.func,
  handleTargetOnBlur: PropTypes.func,
  handleThresholdOnBlur: PropTypes.func,
};

export default SweepsComponent;
